import type { ComponentPropsWithRef } from 'react';
import { cn } from '@/shared/lib/utils';

/**
 * Tableヘッダーコンポーネント
 */
type TableHeaderProps = ComponentPropsWithRef<'thead'>;

export const TableHeader = ({ className, ref, ...props }: TableHeaderProps) => (
  <thead
    ref={ref}
    className={cn('[&_tr]:border-b', 'border-border-strength1 bg-border-subtle1', className)}
    {...props}
  />
);
